export default __webpack_public_path__ + "static/media/rain.b514b9cd.jpg";